// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 38335 ? "auth-suite-store" : chunkId) + "-" + {"38335":"8cc8f5e56bb39209eb84","52283":"e66aa5ff6d8d2a28d409"}[chunkId] + ".min.js";
};